import { useMemo } from 'react';

import { CarrierServiceTagBank } from '../../../../../components/carrier-service-tag-bank';
import { DeliveryExpectation } from '../delivery-expectation';
import { ReadonlyShopperServiceOverride } from '../readonly-shopper-service-override';
// @ts-expect-error less import
import style from './style.module.less';
import { ShopperBulletCompareServices } from '../shopper-bullet-text/shopper-bullet-compare-services';
import { ShopperBulletDeliveryRestriction } from '../shopper-bullet-text/shopper-bullet-delivery-restriction';
import { ShopperBulletSelectLowestRate } from '../shopper-bullet-text/shopper-bullet-select-lowest-rate';
import { ShopperBulletServiceOverride } from '../shopper-bullet-text/shopper-bullet-service-override';
import { ShopperTask } from '../shopper-task';
import { ShopperTasks } from '../shopper-tasks';

/**
 * @typedef {import('../../../../../prop-types/rate-shopper').RateShopper} RateShopper
 * @typedef {import('../../../../../prop-types/rate-shopper-carrier-service').RateShopperCarrierService} RateShopperCarrierService
 */

/**
 * @param {object} props
 * @param {RateShopper} props.shopper
 * @param {boolean} [props.shouldShowPackageAndConfirmation]
 * @param {RateShopperCarrierService[]} [props.unsavedServices]
 * @returns {JSX.Element}
 */
export const ReadonlyShopperTasks = ({ shopper, shouldShowPackageAndConfirmation = false, unsavedServices }) => {
  const { maxTransitDays = 0, services, cheapestOverride, useDeliverByDate } = shopper;
  const servicesToShow = unsavedServices || services;
  const hasCheapestOverride = !!cheapestOverride;
  const hasDeliveryRestriction = maxTransitDays > 0;

  const bulletNumberForLastItem = useMemo(() => {
    const countForOverrideAllowance = hasCheapestOverride ? 1 : 0;
    const countForDeliveryRestrictionAllowance = hasDeliveryRestriction || useDeliverByDate ? 1 : 0;
    const countForFirstAndLastStep = 2;
    return countForFirstAndLastStep + countForDeliveryRestrictionAllowance + countForOverrideAllowance;
  }, [hasCheapestOverride, hasDeliveryRestriction, useDeliverByDate]);
  return (
    <ShopperTasks>
      <ShopperTask>
        <ShopperBulletCompareServices />
        <CarrierServiceTagBank
          carrierServices={servicesToShow}
          className={style['shopper-action']}
          shouldSeparateInternationalServices
          shouldShowPackageAndConfirmation={shouldShowPackageAndConfirmation}
        />
      </ShopperTask>
      {hasDeliveryRestriction || useDeliverByDate ? (
        <ShopperTask>
          <ShopperBulletDeliveryRestriction />
          <DeliveryExpectation className={style['shopper-action']} maxTransitDays={maxTransitDays} useDeliverByDate={useDeliverByDate} />
        </ShopperTask>
      ) : null}
      {hasCheapestOverride ? (
        <ShopperTask>
          <ShopperBulletServiceOverride hasOverride={hasCheapestOverride} stepNumber={hasDeliveryRestriction ? 3 : 2} />
          <ReadonlyShopperServiceOverride
            cheapestOverride={cheapestOverride}
            className={style['shopper-action']}
            services={servicesToShow}
          />
        </ShopperTask>
      ) : null}
      <ShopperTask>
        <ShopperBulletSelectLowestRate hasOverride={hasCheapestOverride} stepNumber={bulletNumberForLastItem} />
      </ShopperTask>
    </ShopperTasks>
  );
};
